import React, { useState } from 'react';
import { mockData } from '../mock';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Phone, Mail, MessageCircle, Clock } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Nachricht gesendet! Wir werden uns so schnell wie möglich bei Ihnen melden.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contact" className="py-24 bg-[#F5F3ED]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3A2E] mb-4">
            Kontaktieren Sie uns
          </h2>
          <p className="text-lg text-[#1A3A2E]/70 max-w-4xl mx-auto">
            Schreiben Sie uns oder rufen Sie uns an. Alternativ können Sie uns direkt über unser Kontaktformular rechts anschreiben. Wir freuen uns auf Ihre Nachricht!
          </p>
        </div>

        {/* Partner Logos */}
        <div className="mb-16">
          <p className="text-center text-[#1A3A2E]/70 text-sm mb-6">Wir arbeiten mit führenden Marken</p>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-6 items-center max-w-5xl mx-auto">
            {mockData.partners.map((partner, idx) => (
              <div
                key={idx}
                className="p-2 rounded-lg flex items-center justify-center h-52 transition-all duration-300"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-full w-full object-contain hover:scale-105 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-8">
            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-[#1A3A2E] mb-6">Schreiben Sie uns</h3>
                <p className="text-[#1A3A2E]/70 mb-6">
                  Schreiben Sie uns eine E-Mail. Wir antworten Ihnen so schnell wie möglich.
                </p>
                <div className="space-y-4">
                  <a
                    href={`mailto:${mockData.company.email}`}
                    className="flex items-center space-x-3 text-[#1A3A2E] hover:text-[#2D4A3E] transition-colors"
                  >
                    <Mail className="w-5 h-5" />
                    <span>{mockData.company.email}</span>
                  </a>
                  <div className="flex items-start space-x-3 text-[#1A3A2E]">
                    <MessageCircle className="w-5 h-5 mt-1" />
                    <div>
                      <p>{mockData.company.address.street}</p>
                      <p>{mockData.company.address.zip} {mockData.company.address.city}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-[#1A3A2E] mb-6">Rufen Sie uns an</h3>
                <p className="text-[#1A3A2E]/70 mb-6">
                  Sie benötigen schnell Hilfe? Greifen Sie zum Hörer und sprechen Sie mit uns.
                </p>
                <div className="space-y-4">
                  <a
                    href={`tel:${mockData.company.phone.replace(/\s/g, '')}`}
                    className="flex items-center space-x-3 text-[#1A3A2E] hover:text-[#2D4A3E] transition-colors font-semibold text-lg"
                  >
                    <Phone className="w-5 h-5" />
                    <span>{mockData.company.phone}</span>
                  </a>
                </div>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-[#1A3A2E] mb-6">Geschäftszeiten</h3>
                <div className="space-y-3 text-[#1A3A2E]/70">
                  <div className="flex items-start space-x-3">
                    <Clock className="w-5 h-5 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-[#1A3A2E]">MO - DO</p>
                      <p>8:00 Uhr - 18:00 Uhr</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Clock className="w-5 h-5 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-[#1A3A2E]">FREITAG</p>
                      <p>8:00 Uhr - 15:00 Uhr</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <Card className="border-none shadow-2xl bg-white">
            <CardContent className="p-8">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-[#1A3A2E] mb-2">Name</label>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#1A3A2E] mb-2">Email</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#1A3A2E] mb-2">Phone</label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#1A3A2E] mb-2">Nachricht</label>
                  <Textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full bg-[#1A3A2E] text-white hover:bg-[#2D4A3E] py-6 text-lg"
                >
                  Absenden
                </Button>
                <p className="text-center text-sm text-[#1A3A2E]/70">
                  Wir antworten Ihnen so schnell wie möglich.
                </p>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;